'use client'

import * as React from 'react'

import { cn } from '@/lib/utils'

function Label({
  className,
  variant = 'default',
  ...props
}: React.ComponentProps<'label'> & { variant?: 'default' | 'parameter' }) {
  return (
    <label
      data-slot="label"
      className={cn(
        'flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        variant === 'parameter' && 'font-normal',
        className,
      )}
      {...props}
    />
  )
}

export { Label }
